import React from 'react';
import { motion } from 'framer-motion';
import { TriangleAlertIcon, XIcon } from 'lucide-react';
import { costs } from '../data/problems';
export function CostSection() {
  return <section className="bg-stage bg-grid py-16 sm:py-20" aria-labelledby="cost-title" data-id="element-60" data-mp="4ky9kgrdn0fu">
      <div className="mx-auto max-w-4xl px-4" data-id="element-61" data-mp="3vriv5kynxg5h">
        <div className="text-center" data-id="element-62" data-mp="3vqpv12u7lowb">
          <TriangleAlertIcon className="mx-auto h-9 w-9 text-gold" data-id="element-63" data-mp="3vpoj6w5dcydj" />
          <h2 id="cost-title" className="mt-4 text-3xl font-extrabold uppercase text-white sm:text-4xl" data-id="element-64" data-mp="3qtzhon9sh7el">El costo de no tenerlo</h2>
          <p className="mt-3 text-mutedDark" data-id="element-65" data-mp="3mt75bl5meme3">Lo que realmente perdés cada ciclo lectivo sin el Megapack</p>
        </div>

        <div className="mt-10 space-y-2" data-id="element-66" data-mp="3cswsw2retizz">
          {costs.map(([without, loss], index) => <motion.div key={without} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.03,
          ease: [0.23, 1, 0.32, 1]
        }} className="panel-dark grid gap-2 rounded-sm border border-lineDark p-4 sm:grid-cols-[minmax(0,1fr)_minmax(0,1.6fr)] sm:gap-6" data-id="element-67" data-mp="1g04rblzzqawl" data-mpi={index}>
              <p className="flex items-start gap-2 text-sm font-bold text-white" data-id="element-68" data-mp="fafb0tyhcw8v">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" data-id="element-69" data-mp="k7p0g9lvd7wp" />
                {without}
              </p>
              <p className="text-sm leading-relaxed text-mutedDark" data-id="element-70" data-mp="17z490k48olge">{loss}</p>
            </motion.div>)}
        </div>

        <blockquote className="panel-dark mt-10 rounded-md border border-gold/35 border-l-2 border-l-gold p-6 text-center text-sm font-semibold leading-relaxed text-onDark sm:p-8" data-id="element-71" data-mp="1cwco2bu3c9df">
          “La próxima vez que un alumno pregunte para qué sirve estudiar Automatización Industrial, podés mostrarle que Argentina
          tiene empresas que requieren estos técnicos, que la automatización aumenta la precisión y eficiencia, que aprender PLC
          es aprender el lenguaje del control industrial moderno, que ser un técnico especializado es tener oportunidades
          laborales reales, y que cada proyecto que hacen en el aula es una simulación de lo que harán en el trabajo. O podés
          seguir explicando sin ese contexto.”
        </blockquote>
      </div>
    </section>;
}